// T049 — Boost initiated event definition.

import type { EventDefinition } from './navigation';

export type BoostInitiatedProperties = {
  marketPubkey: string;
  amountUsdc: number;
};

export const BOOST_INITIATED: EventDefinition<BoostInitiatedProperties> = {
  name: 'boost_initiated',
};
